import { useExperimentTreatment } from '@ms/yammer-experiments-context';
import type { FC } from 'react';
import React, { Suspense } from 'react';

import type { AppNavigationProps } from '../AppNavigation/AppNavigation';
import AppNavigation from '../AppNavigation/LoadableAppNavigation';

import LoadableResizableAppNavigationInner from './LoadableResizableAppNavigationInner';

export const ResizableAppNavigation: FC<AppNavigationProps> = (props) => {
  const isEnabled = useExperimentTreatment('EngageIASimplificationNavRefresh');

  if (!isEnabled) {
    return <AppNavigation {...props} />;
  }

  return (
    <Suspense fallback={<AppNavigation {...props} />}>
      <LoadableResizableAppNavigationInner {...props} />
    </Suspense>
  );
};
